
import { useState, useEffect } from 'react';
import { CalendarViewMode } from '../types';
import { useUser } from '@/contexts/UserContext';

export const useScheduleState = () => {
  const { isAdmin, isManager } = useUser();
  const [isCustomView, setIsCustomView] = useState<boolean>(false);
  const [selectedGuardId, setSelectedGuardId] = useState<string>('');
  const [isTemplatesDialogOpen, setIsTemplatesDialogOpen] = useState<boolean>(false);
  const [showQuickEditDialog, setShowQuickEditDialog] = useState<boolean>(false);
  const [quickEditEvent, setQuickEditEvent] = useState<any>(null);
  
  // Guards should only see 'per-job' view (ανά ποστο), not 'standard'
  const isGuard = !isAdmin && !isManager;
  const [viewType, setViewType] = useState<'standard' | 'per-job'>(isGuard ? 'per-job' : 'standard');
  
  const [customClearRange, setCustomClearRange] = useState<{ from: Date, to: Date } | null>(null);
  const [isLoadingMoreShifts, setIsLoadingMoreShifts] = useState<boolean>(false);
  const [extendedDateRange, setExtendedDateRange] = useState<boolean>(false);

  // Force guards to stay in 'per-job' view
  useEffect(() => {
    if (isGuard && viewType !== 'per-job') {
      setViewType('per-job');
    }
  }, [isGuard, viewType]);

  return {
    isCustomView,
    setIsCustomView,
    selectedGuardId,
    setSelectedGuardId,
    isTemplatesDialogOpen,
    setIsTemplatesDialogOpen,
    showQuickEditDialog,
    setShowQuickEditDialog,
    quickEditEvent,
    setQuickEditEvent,
    viewType,
    setViewType: isGuard ? () => {} : setViewType, // Guards can't change view type
    customClearRange,
    setCustomClearRange,
    isLoadingMoreShifts,
    setIsLoadingMoreShifts,
    extendedDateRange,
    setExtendedDateRange,
    isGuard
  };
};
